import { render, staticRenderFns } from "./DeleteVirtualStation.vue?vue&type=template&id=7b8a6d00&scoped=true"
import script from "./DeleteVirtualStation.vue?vue&type=script&lang=js"
export * from "./DeleteVirtualStation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8a6d00",
  null
  
)

export default component.exports